import { AxiosResponse } from 'axios';

const RequestWrapper = async (request: Promise<AxiosResponse<any, any>>) => {
	let data = null;
	let error = null;

	try {
		const response = await request;
		data = response.data;
	} catch (err) {
		error = err;
	}

	return [data, error];
};

export default RequestWrapper;
